'use strict';

import angular from 'angular';
import ActiveController from './active.controller';

export default angular.module('updateServerApp.myscripts.active', [])
  .controller('MyScriptsActiveController', ActiveController)
  .name;



// WEBPACK FOOTER //
// ./client/app/myscripts/active/index.js